module.exports = [{"name":"Rolled products","file":"/static/files/catalogues/alcomet-rolled-products.pdf","img":"/static/files/catalogues/alcomet-rolled-products.jpg","date":"11.09.2022"},{"name":"Extruded products","file":"/static/files/catalogues/alcomet-profiles.pdf","img":"/static/files/catalogues/alcomet-profiles.jpg","date":"12.09.2022"},{"name":"Alcomet Catalogue","file":"/static/files/catalogues/catalogue_alcomet.pdf","img":"/static/files/catalogues/catalogue_alcomet.jpg","date":"17.09.2022"}]


//////////////////
// WEBPACK FOOTER
// ./src/components/download-center/catalogues.json
// module id = pZMA
// module chunks = 1